import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";
import { HearingNotice } from "../../../../../../utilities/interfaces/HearingNotice";
import { getByFilingId } from "../../../../../../features/state/StateHearingNotice-slice";
import { FilingAction } from "../../../../../../utilities/interfaces/FilingAction";
import { getAllFilingActions } from "../../../../../../features/state/StateFilingAction-slice";
import { hearingNoticeCommentApi } from "../../../../../../utilities/api/hearingNoticeCommentApi";
import { CreateEmptyHearingNoticeComment, HearingNoticeComment } from "../../../../../../utilities/interfaces/HearingNoticeComment";
import { hearingNoticeApi } from "../../../../../../utilities/api";

export const useHearingNoticeController = (filingId: number) => {
  // REDUX
  const hearingNotices: HearingNotice[] = useAppSelector((state) => state.hearingNotice.hearingNotices);
  const filingActions: FilingAction[] = useAppSelector((state) => state.filingActions.value);
  const creatingHearingNotice: boolean = useAppSelector((state) => state.hearingNotice.creatingHearingNotice);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (filingId) {
      dispatch(getByFilingId(filingId));
    }
    if (filingActions.length < 1) {
      dispatch(getAllFilingActions());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //#region comments

  const [newCommentDialogOpen, setNewCommentDialogOpen] = useState<boolean>(false);

  const toggleNewCommentDialog = (hearingNoticeId?: number) => {
    setNewCommentDialogOpen(!newCommentDialogOpen);
    if (hearingNoticeId) {
      setNewComment({...newComment, hearingNoticeId});
    }
    else {
      setNewComment(CreateEmptyHearingNoticeComment());
    }
  }

  const [newComment, setNewComment] = useState<any>(CreateEmptyHearingNoticeComment());

  const saveNewComment = () => {
    delete newComment.id;
    hearingNoticeCommentApi.createHearingNoticeComment(newComment)
      .then(() => {
        dispatch(getByFilingId(filingId));
      });
  }

  //#endregion

  const deleteHearingNotice = () => {
    hearingNoticeApi.delete(idToDelete)
      .then(() => {
        dispatch(getByFilingId(filingId));
      });
  }

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState<boolean>(false);
  const [idToDelete, setIdToDelete] = useState<any>();

  const toggleConfirmDelete = (id?: any) => {
    setConfirmDeleteOpen(!confirmDeleteOpen);
    setIdToDelete(id);
  }

  const parseUTCDate = (date: any) => {
    return new Date(date[date.length - 1] === 'Z' ? date : date.concat('Z')).toLocaleString();
  }

  return {
    // REDUX
    hearingNotices,
    filingActions,
    creatingHearingNotice,
    // data
    newCommentDialogOpen,
    newComment,
    confirmDeleteOpen,
    // Functions
    toggleNewCommentDialog,
    saveNewComment,
    deleteHearingNotice,
    toggleConfirmDelete,
    parseUTCDate,
  }
}